import * as React from 'react';
import { useContext } from 'react';

type CourseraPlusContextType = {
  isUserEligibleToSeeCta?: boolean;
  isSubscribedToCPlusOrLite?: boolean;
  isCourseraPlusEligibleProduct?: boolean;
  isSubscribedToCourseraLite?: boolean;
  showPlusMonthlyToAnnualUpgradeButton?: boolean;
  isEligibleForPlusMonthlyToAnnualUpgrade?: boolean;
};

const CourseraPlusOwnershipContext = React.createContext<CourseraPlusContextType | undefined>(undefined);

export const useCourseraPlusOwnership = () => {
  const courseraPlusOwnership = useContext(CourseraPlusOwnershipContext);

  return courseraPlusOwnership;
};

export default CourseraPlusOwnershipContext;
